<template>
  <relation type="list" />
</template>
<script>
import Relation from './relation/Relation'
export default {
  components: {
    Relation
  }
}
</script>
